import { render, staticRenderFns } from "./ReplacementCopyEdit.vue?vue&type=template&id=497dc015&scoped=true&"
import script from "./ReplacementCopyEdit.vue?vue&type=script&lang=js&"
export * from "./ReplacementCopyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497dc015",
  null
  
)

export default component.exports